/**
 * @generated SignedSource<<b4b663777dfb972d3305409de5698d48>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type tableBody_nativeIssueTable_rankField$data = {
  readonly fieldId: string | null | undefined;
  readonly " $fragmentType": "tableBody_nativeIssueTable_rankField";
};
export type tableBody_nativeIssueTable_rankField$key = {
  readonly " $data"?: tableBody_nativeIssueTable_rankField$data;
  readonly " $fragmentSpreads": FragmentRefs<"tableBody_nativeIssueTable_rankField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "tableBody_nativeIssueTable_rankField",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "e499c939a58a243654edac453c93ea33";

export default node;
